// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__HJf70","type":"styles_type__qdy_g","choices":"styles_choices__Eh54I"};